export { default } from './modules/RelativeTimeFormat'


//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-format/index.js
// module id = 586
// module chunks = 0